import type { TFunction } from "i18next";

export interface FaqItem {
	question: string;
	answer: string;
}

export function getFaqItems(t: TFunction<"marketing">): FaqItem[] {
	return [
		{ question: t("faq_private_question"), answer: t("faq_private_answer") },
		{ question: t("faq_group_question"), answer: t("faq_group_answer") },
		{ question: t("faq_platform_question"), answer: t("faq_platform_answer") },
		{ question: t("faq_content_question"), answer: t("faq_content_answer") },
		{ question: t("faq_multi_group_question"), answer: t("faq_multi_group_answer") },
		{ question: t("faq_security_question"), answer: t("faq_security_answer") },
		{ question: t("faq_web_question"), answer: t("faq_web_answer") },
		{ question: t("faq_delete_account_question"), answer: t("faq_delete_account_answer") },
		{ question: t("faq_age_question"), answer: t("faq_age_answer") },
		{ question: t("faq_support_question"), answer: t("faq_support_answer") },
		{ question: t("faq_languages_question"), answer: t("faq_languages_answer") },
		{ question: t("faq_price_question"), answer: t("faq_price_answer") },
	];
}

export function getHomeFaqItems(t: TFunction<"marketing">): FaqItem[] {
	return getFaqItems(t).slice(0, 6);
}
